"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cpReportAddReportDefaultApi = cpReportAddReportDefaultApi;
exports.cpReportAddUpdateReportDefaultApi = cpReportAddUpdateReportDefaultApi;
exports.cpReportDeletePanelApi = cpReportDeletePanelApi;
exports.cpReportGetAssetFolderListApi = cpReportGetAssetFolderListApi;
exports.cpReportGetBuilderReportByIdApi = cpReportGetBuilderReportByIdApi;
exports.cpReportGetGreetingApi = cpReportGetGreetingApi;
exports.cpReportGetHeaderImageApi = cpReportGetHeaderImageApi;
exports.cpReportGetHeaderImageListApi = cpReportGetHeaderImageListApi;
exports.cpReportGetReportDefaultApi = cpReportGetReportDefaultApi;
exports.cpReportGetReportDefaultByOrgIdApi = cpReportGetReportDefaultByOrgIdApi;
exports.cpReportPanelListApi = cpReportPanelListApi;
exports.cpReportUpdateFundSequencePanelApi = cpReportUpdateFundSequencePanelApi;
exports.cpReportUpdateGreetingApi = cpReportUpdateGreetingApi;
exports.cpReportUpdateHeaderImageApi = cpReportUpdateHeaderImageApi;
exports.cpReportUpdatePanelApi = cpReportUpdatePanelApi;
var _core = require("../../../core/core.service");
var _app = _interopRequireDefault(require("../../../../configs/app.config"));
var _dashboard = require("../../../../constants/endpoints/dashboard");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// @flow

var api = new _core.APICore();

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetReportDefaultApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.getReportDefault), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
function cpReportAddReportDefaultApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.addReportDefault), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportAddUpdateReportDefaultApi(params) {
  return api.create("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.addUpdateReportDefault), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
function cpReportGetReportDefaultByOrgIdApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.getReportDefaultByOrgId), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportUpdateGreetingApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.updateGreeting), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
function cpReportUpdateHeaderImageApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.updateHeaderImage), params);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
function cpReportUpdateFundSequencePanelApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.updateFundSequencePanel), params);
}
/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetHeaderImageApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.getHeaderImage), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetBuilderReportByIdApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.getBuilderReportById), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
function cpReportGetAssetFolderListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.getAssetFolderList), params);
}

/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportPanelListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.panelList), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
function cpReportGetGreetingApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.getGreeting), params);
}

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete data.
 */
function cpReportDeletePanelApi(params) {
  return api.delete("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.deletePanel), params);
}

/**
 * update
 * @param payload
 * @returns api response
 * @description this function used to update data.
 */
function cpReportUpdatePanelApi(params) {
  return api.update("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.panelList), params);
}
/**
 * get
 * @param payload
 * @returns api response
 * @description this function used to get data.
 */
function cpReportGetHeaderImageListApi(params) {
  return api.get("".concat(_app.default.baseUrl + _dashboard.ContentPanelService.cpReport.headerImageList), params);
}